import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["display", "disabled"];
import styled from 'styled-components';
import { filterProps } from '../../utils';
import { useMapStylePropsToCSS } from '../../hooks/useMapStylePropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledImage = styled.img.withConfig({
  displayName: "Image__StyledImage",
  componentId: "gu56og-0"
})(({
  $cssStyles: _$cssStyles,
  $disabled
}) => {
  const $cssStyles = _$cssStyles;
  return Object.assign({}, $cssStyles, {
    boxSizing: 'border-box',
    opacity: $disabled ? 0.5 : 1
  });
});
export const Image = _ref => {
  let {
      display = 'inline-block',
      disabled = false
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    styleProps
  } = filterProps(Object.assign({}, restProps, {
    display
  }), {
    isImage: true
  });
  const cssStyles = useMapStylePropsToCSS(styleProps);
  return /*#__PURE__*/_jsx(StyledImage, Object.assign({}, domProps, {
    $cssStyles: cssStyles,
    $disabled: disabled
  }));
};